import { Col, Form, Input, Modal, Row, Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import * as React from 'react';
import { Provider, Subscribe, Container } from 'unstated';

import { StateContainer } from './StateContainer';
import { convertFileToUrl } from '../../../helpers/convertProductImagesToUploadFiles';
import { url } from '../../../config/config';

interface IManufacturerDetailProps {
    manufacturer: GQL.IManufacturer;
    onSave: (manufacturer: GQL.IManufacturer, image: any) => void;
    onCancel: () => void;
}

export default class ManufacturerDetail extends React.Component<IManufacturerDetailProps> {
    private manufacturerContainer: StateContainer;

    public constructor(props: IManufacturerDetailProps) {
        super(props);
        this.manufacturerContainer = new StateContainer({
            manufacturer: props.manufacturer
        });

        this.save = this.save.bind(this);
    }

    public render() {
        const { manufacturer } = this.manufacturerContainer.state;

        const imageUrl = this.manufacturerContainer.state.manufacturer.manufacturerImage
            ? convertFileToUrl(this.manufacturerContainer.state.manufacturer.manufacturerImage.file, url)
            : undefined;

        const uploadButton = (
            <div>
                {false ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        return (
            <Provider>
                <Subscribe to={[this.manufacturerContainer]}>
                    {detail => (
                        <Modal
                            // maskClosable={false}
                            style={{ top: '5vh' }}
                            width={'50%'}
                            bodyStyle={{ minHeight: '80vh' }}
                            title={`Manufacturer ${manufacturer && manufacturer.name}`}
                            visible={true}
                            cancelText={'Close'}
                            okText={'Save changes'}
                            onOk={this.save}
                            onCancel={() => this.props.onCancel()}
                        >
                            <Row>
                                <Col span={24}>
                                    <Form>
                                        <Form.Item>
                                            <Upload
                                                name="avatar"
                                                listType="picture-card"
                                                className="avatar-uploader"
                                                showUploadList={false}
                                                beforeUpload={() => false}
                                                fileList={detail.state.image ? [detail.state.image] : []}
                                                onChange={change =>
                                                    this.manufacturerContainer.setState({ image: change.file })
                                                }
                                            >
                                                {detail.state.image ? (
                                                    <span>{detail.state.image.name}</span>
                                                ) : imageUrl ? (
                                                    <img style={{ width: 100 }} src={imageUrl} alt="avatar" />
                                                ) : (
                                                    uploadButton
                                                )}
                                            </Upload>
                                        </Form.Item>
                                        <Form.Item
                                            validateStatus={
                                                this.manufacturerContainer.state.errors.name ? 'error' : undefined
                                            }
                                            help={this.manufacturerContainer.state.errors.name}
                                        >
                                            <Input
                                                autoFocus={true}
                                                name={'name'}
                                                placeholder="Manufacturer's name"
                                                defaultValue={manufacturer.name}
                                                onChange={e => this.onChange('name', e.target.value)}
                                            />
                                        </Form.Item>
                                        <Form.Item>
                                            <Input
                                                name={'description'}
                                                placeholder="Manufacturer's description"
                                                defaultValue={manufacturer.description || ''}
                                                onChange={e => this.onChange('description', e.target.value)}
                                            />
                                        </Form.Item>
                                    </Form>
                                </Col>
                            </Row>
                        </Modal>
                    )}
                </Subscribe>
            </Provider>
        );
    }
    private onChange(key: string, val: any) {
        this.manufacturerContainer.onChange(key, val);
    }

    private async save() {
        const errors = await this.manufacturerContainer.validate(); // TODO
        let anyError = false;

        for (const key of Object.keys(errors)) {
            if (errors[key] != undefined) {
                anyError = true;
            }
        }

        if (!anyError) {
            this.props.onSave(this.manufacturerContainer.state.manufacturer, this.manufacturerContainer.state.image);
        } else {
            console.log('there is error, can not save', errors);
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Manufacturers/ManufacturerDetail/ManufacturerDetail.tsx